import { Actions, ofType } from '@ngrx/effects';
import { merge, Observable } from 'rxjs';
import { messageConversationChanged, messageConversationsLoaded } from '../../messages/actions/message-conversation.actions';
import { emailConversationChanged, emailConversationsLoaded } from '../../emails/actions/email-conversation.actions';
import { ConversationAction, ConversationsAction } from '../models/conversation-action.model';
import { ConversationBase } from '../models/conversation-base.model';

export const getConversationLoadedActions$ = (actions$: Actions): Observable<ConversationsAction<ConversationBase>> => merge(
  actions$.pipe(ofType(messageConversationsLoaded)),
  actions$.pipe(ofType(emailConversationsLoaded))
);

export const getConversationChangedActions$ = (actions$: Actions): Observable<ConversationAction<ConversationBase>> => merge(
  actions$.pipe(ofType(messageConversationChanged)),
  actions$.pipe(ofType(emailConversationChanged))
);
